import { ChangeDetectorRef, Directive, HostListener, inject, OnDestroy } from '@angular/core';
import { FormGroup, UntypedFormGroup, ValidatorFn } from '@angular/forms';

import { BehaviorSubject, pairwise, takeUntil } from 'rxjs';

import { ScreenBreakpointPX } from '@summit/core';
import { SummitDisposing } from '@summit/models';
import { ApiError } from '@summit/ui';

export interface ISummitForm {
  elementForm: FormGroup;
  hasUnSavedData(): boolean;
}

@Directive()
export abstract class SummitFormBase extends SummitDisposing implements ISummitForm, OnDestroy {
  elementForm: FormGroup;
  apiError: ApiError = new ApiError();
  nonFormDataDirty = false;
  submittingBs = new BehaviorSubject<boolean>(false);
  submitting$ = this.submittingBs.asObservable();
  protected cd: ChangeDetectorRef;
  protected skipUnloadTest: boolean;
  ScreenBreakpoint = ScreenBreakpointPX;
  constructor() {
    super();
    this.cd = inject(ChangeDetectorRef);
  }

  hasUnSavedData(): boolean {
    /*
    console.log(
      `Testing Unsaved Data: submitting: ${this.submitting$.value}, form: ${this.elementForm.dirty}, non-form:${this.nonFormDataDirty}`,
      this.elementForm
    );
    Object.keys(this.elementForm.controls).forEach((key) => {
      console.log(`${key}:`, this.elementForm.controls[key].dirty);
    });
    */
    return !this.submittingBs.value && (this.elementForm?.dirty || this.nonFormDataDirty);
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: Event) {
    if (!this.skipUnloadTest && this.hasUnSavedData()) {
      $event.returnValue = true;
    }
  }

  protected preSaveCheck(): boolean {
    const debugging = false;
    this.submittingBs.next(true);
    this.elementForm.updateValueAndValidity();
    if (this.elementForm.invalid) {
      this.elementForm.markAllAsTouched();
      //console.log('detecting changes');
      this.cd.detectChanges();
      if (debugging) console.log('disabling submit');
      this.submittingBs.next(false);
      console.warn('Form is invalid, not submitting.', this.submittingBs.value);
      //console.log(`Form Errors: `, this.elementForm.errors, this.elementForm);
      // Object.keys(this.elementForm.controls).forEach((key) => {
      //   const control = this.elementForm.get(key);
      //   //if (control.errors) console.log(`${key}:`, control.errors);
      // });
      return false;
    }
    return true;
  }

  override ngOnDestroy(): void {
    this.submittingBs.next(false);
    this.submittingBs.complete();
    // Not sure if this is cascaded or not
    this.disposing$.next(null);
    this.disposing$.complete();
    super.ngOnDestroy();
  }

  configureForm() {
    this.elementForm.addValidators(this.apiErrorValidator.bind(this) as ValidatorFn);
    this.elementForm.valueChanges.pipe(pairwise(), takeUntil(this.disposing$)).subscribe(([oldValue, newValue]) => {
      const apiErrorModel = this.apiError?.model;
      if (apiErrorModel) {
        Object.keys(apiErrorModel).forEach((key) => {
          const lclControl = this.elementForm.get(key);
          if (lclControl?.errors?.['apiError'] && oldValue[key] !== newValue[key]) {
            if (apiErrorModel[key]) delete apiErrorModel[key];
            lclControl.updateValueAndValidity();
          }
        });
      }
    });
  }

  apiErrorValidator(formGroup: UntypedFormGroup) {
    if (this.apiError?.model) {
      Object.keys(this.apiError.model).forEach((key) => {
        const lclControl = formGroup.get(key);
        if (lclControl) {
          if (!lclControl.errors?.['apiError']) lclControl.setErrors({ apiError: true });
        } else console.warn(`Could not find control for ${key} to set error.`);
      });
    }
  }
}
